import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('publicaciones');
  const [isEditing, setIsEditing] = useState(false);
  const [editingPublication, setEditingPublication] = useState<any>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingPublication, setDeletingPublication] = useState<any>(null);
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);

  // Datos de ejemplo del usuario
  const [user, setUser] = useState({
    name: 'Juan Carlos López',
    email: 'juan.lopez@email.com',
    phone: '+52 55 1234 5678',
    city: 'Ciudad de México',
    state: 'Ciudad de México',
    company: 'Deportes López S.A. de C.V.',
    companyAddress: 'Av. Insurgentes Sur 1234, Col. Del Valle',
    companyPhone: '+52 55 8765 4321',
    taxId: 'DLO901123ABC',
    license: 'Premium',
    licenseExpiry: '2024-12-31',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20mexican%20male%20profile%20photo%2C%20friendly%20smile%2C%20business%20casual%20attire%2C%20clean%20background%2C%20professional%20headshot%20for%20sports%20platform&width=150&height=150&seq=user-avatar&orientation=squarish'
  });

  const [userPublications, setUserPublications] = useState([
    {
      id: 1,
      name: 'Cancha Los Tigres',
      location: 'Polanco, Ciudad de México',
      category: 'Fútbol 11',
      price: 800,
      status: 'activo',
      views: 245,
      bookings: 12,
      state: 'Ciudad de México',
      city: 'Ciudad de México',
      address: 'Av. Polanco 1234, Col. Polanco',
      description: 'Cancha de fútbol profesional con césped sintético de alta calidad, iluminación LED y vestidores completos.',
      features: ['Césped sintético', 'Iluminación', 'Vestidores', 'Estacionamiento'],
      image: 'https://readdy.ai/api/search-image?query=professional%20soccer%20field%20with%20green%20artificial%20turf%2C%20stadium%20lights%2C%20goal%20posts%2C%20modern%20sports%20facility&width=300&height=200&seq=pub1&orientation=landscape'
    },
    {
      id: 2,
      name: 'Arena Deportiva Premium',
      location: 'Santa Fe, Ciudad de México',
      category: 'Futsal',
      price: 450,
      status: 'pendiente',
      views: 89,
      bookings: 3,
      state: 'Ciudad de México',
      city: 'Ciudad de México',
      address: 'Av. Santa Fe 567, Col. Santa Fe',
      description: 'Cancha de futsal techada con piso de duela profesional, perfecta para entrenamientos y torneos.',
      features: ['Techada', 'Vestidores', 'Gradas', 'Seguridad'],
      image: 'https://readdy.ai/api/search-image?query=indoor%20futsal%20court%20with%20wooden%20floor%2C%20professional%20indoor%20soccer%20facility%2C%20bright%20lighting&width=300&height=200&seq=pub2&orientation=landscape'
    },
    {
      id: 3,
      name: 'Campo Verde',
      location: 'Coyoacán, Ciudad de México',
      category: 'Fútbol 7',
      price: 350,
      status: 'inactivo',
      views: 156,
      bookings: 8,
      state: 'Ciudad de México',
      city: 'Coyoacán',
      address: 'Calle Coyoacán 890, Col. Del Carmen',
      description: 'Campo de fútbol 7 con césped natural, ideal para partidos familiares y de amigos.',
      features: ['Césped natural', 'Estacionamiento', 'Cafetería'],
      image: 'https://readdy.ai/api/search-image?query=soccer%20field%20number%207%20artificial%20grass%2C%20smaller%20football%20pitch%2C%20goal%20posts%2C%20modern%20sports%20center&width=300&height=200&seq=pub3&orientation=landscape'
    }
  ]);

  const memberships = [
    {
      id: 1,
      name: 'Plan Básico',
      price: '$99/mes',
      features: ['Hasta 2 anuncios', 'Soporte por email', 'Estadísticas básicas'],
      current: true
    },
    {
      id: 2,
      name: 'Plan Premium',
      price: '$199/mes',
      features: ['Anuncios ilimitados', 'Soporte prioritario', 'Estadísticas avanzadas', 'Promoción destacada'],
      current: false
    },
    {
      id: 3,
      name: 'Plan Pro',
      price: '$299/mes',
      features: ['Todo del Premium', 'Múltiples ubicaciones', 'API acceso', 'Manager dedicado'],
      current: false
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'activo': return 'text-green-600 bg-green-50';
      case 'pendiente': return 'text-yellow-600 bg-yellow-50';
      case 'inactivo': return 'text-gray-600 bg-gray-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const handleSaveProfile = () => {
    setIsEditing(false);
    // Aquí se guardarían los cambios del perfil
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Simular carga de imagen
      const reader = new FileReader();
      reader.onload = (e) => {
        setUser(prev => ({ ...prev, avatar: e.target?.result as string }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditPublication = (publication: any) => {
    setEditingPublication({ ...publication });
    setShowEditModal(true);
  };

  const handleSaveEditedPublication = () => {
    // Aquí se guardarían los cambios de la publicación
    setShowEditModal(false);
    setEditingPublication(null);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingPublication(null);
  };

  const handleDeletePublication = (publication: any) => {
    setDeletingPublication(publication);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (deletingPublication) {
      setUserPublications(prev => prev.filter(pub => pub.id !== deletingPublication.id));
      setShowDeleteModal(false);
      setDeletingPublication(null);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeletingPublication(null);
  };

  const handleDeleteAccount = () => {
    setShowDeleteAccountModal(true);
  };

  const handleConfirmDeleteAccount = () => {
    // Aquí se eliminaría la cuenta del usuario
    console.log('Cuenta eliminada');
    setShowDeleteAccountModal(false);
    // Redirigir al inicio después de eliminar
    window.location.href = '/';
  };

  const handleCloseDeleteAccountModal = () => {
    setShowDeleteAccountModal(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-green-600 shadow-sm border-b">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex items-center">
                <img
                  src="https://storage.readdy-site.link/project_files/84f75d7c-5aa3-41e4-b7ad-dd29b3b984c6/838cdbab-d32d-4b26-b12c-15bffc18506a_poktapok_v1_sin-fondo.png"
                  alt="PokTaPok"
                  className="h-12 w-auto object-contain cursor-pointer"
                />
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-8 h-8 rounded-full object-cover border-2 border-white"
                />
                <span className="hidden md:block text-white font-medium">{user.name}</span>
              </div>
              <Button variant="outline" size="sm" className="whitespace-nowrap text-white border-white hover:bg-white hover:text-green-600">
                <i className="ri-logout-line mr-2"></i>
                Cerrar Sesión
              </Button>
            </div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <Card className="p-6">
              <div className="text-center mb-6">
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="font-bold text-lg text-gray-800">{user.name}</h3>
                <p className="text-gray-600 text-sm">{user.email}</p>
                
                {/* License Info */}
                <div className="mt-4 p-3 bg-gradient-to-r from-green-600 to-green-700 rounded-lg text-white">
                  <div className="flex items-center justify-center space-x-2 mb-1">
                    <i className="ri-vip-crown-line"></i>
                    <span className="font-bold text-sm">Licencia {user.license}</span>
                  </div>
                  <p className="text-xs opacity-90">Vence: {user.licenseExpiry}</p>
                </div>
              </div>
              
              <nav className="space-y-2">
                <button
                  onClick={() => setActiveTab('publicaciones')}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
                    activeTab === 'publicaciones' ? 'bg-gradient-to-r from-green-600 to-green-700 text-white' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-file-list-line"></i>
                  <span>Mis Publicaciones</span>
                </button>
                <button
                  onClick={() => setActiveTab('crear-anuncio')}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
                    activeTab === 'crear-anuncio' ? 'bg-gradient-to-r from-green-600 to-green-700 text-white' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-add-circle-line"></i>
                  <span>Crear Anuncio</span>
                </button>
                <button
                  onClick={() => setActiveTab('perfil')}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
                    activeTab === 'perfil' ? 'bg-gradient-to-r from-green-600 to-green-700 text-white' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-user-line"></i>
                  <span>Mi Perfil</span>
                </button>
                <button
                  onClick={() => setActiveTab('membresias')}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
                    activeTab === 'membresias' ? 'bg-gradient-to-r from-green-600 to-green-700 text-white' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-vip-crown-line"></i>
                  <span>Membresías</span>
                </button>
              </nav>
            </Card>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            {/* Mis Publicaciones */}
            {activeTab === 'publicaciones' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-800">Mis Publicaciones</h2>
                  <Button 
                    onClick={() => setActiveTab('crear-anuncio')}
                    className="bg-green-700 hover:bg-green-800 whitespace-nowrap"
                  >
                    <i className="ri-add-line mr-2"></i>
                    Nueva Publicación
                  </Button>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {userPublications.map((pub) => (
                    <Card key={pub.id} className="overflow-hidden border-2 border-red-200 hover:border-red-300">
                      <img
                        src={pub.image}
                        alt={pub.name}
                        className="w-full h-48 object-cover object-top"
                      />
                      <div className="p-4">
                        <div className="flex items-center justify-between mb-2">
                          <h3 className="font-bold text-lg">{pub.name}</h3>
                          <div className="flex items-center space-x-2">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(pub.status)}`}>
                              {pub.status.charAt(0).toUpperCase() + pub.status.slice(1)}
                            </span>
                            {/* Switch para activar/desactivar */}
                            <button
                              onClick={() => {
                                setUserPublications(prev => 
                                  prev.map(p => 
                                    p.id === pub.id 
                                      ? { ...p, status: p.status === 'activo' ? 'inactivo' : 'activo' }
                                      : p
                                  )
                                );
                              }}
                              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors cursor-pointer ${
                                pub.status === 'activo' ? 'bg-green-600' : 'bg-gray-300'
                              }`}
                            >
                              <span
                                className={`inline-block h-3 w-3 transform rounded-full bg-white transition ${
                                  pub.status === 'activo' ? 'translate-x-5' : 'translate-x-1'
                                }`}
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex items-center text-gray-600 mb-2">
                          <i className="ri-map-pin-line mr-1"></i>
                          <span className="text-sm">{pub.location}</span>
                        </div>
                        <div className="flex items-center justify-between mb-3">
                          <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                            {pub.category}
                          </span>
                          <span className="text-green-600 font-bold">${pub.price}/hora</span>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                          <div className="text-center">
                            <div className="font-bold text-gray-800">{pub.views}</div>
                            <div className="text-gray-600">Visualizaciones</div>
                          </div>
                          <div className="text-center">
                            <div className="font-bold text-gray-800">{pub.bookings}</div>
                            <div className="text-gray-600">Reservas</div>
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <Button 
                            variant="outline" 
                            size="sm" 
                            className="flex-1 whitespace-nowrap border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white"
                            onClick={() => handleEditPublication(pub)}
                          >
                            Editar
                          </Button>
                          <Button 
                            variant="outline" 
                            size="sm" 
                            className="text-red-600 border-2 border-red-600 hover:bg-red-50 whitespace-nowrap"
                            onClick={() => handleDeletePublication(pub)}
                          >
                            Eliminar
                          </Button>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            )}

            {/* Crear Anuncio */}
            {activeTab === 'crear-anuncio' && (
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Crear Nuevo Anuncio</h2>
                <Card className="p-6 border-2 border-red-200">
                  <form className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre de la Cancha
                        </label>
                        <input
                          type="text"
                          placeholder="Ej: Cancha Los Campeones"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Categoría
                        </label>
                        <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8">
                          <option>Seleccionar categoría</option>
                          <option>Fútbol 11</option>
                          <option>Fútbol 7</option>
                          <option>Fútbol 5</option>
                          <option>Futsal</option>
                          <option>Fútbol Playa</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Precio por Hora
                        </label>
                        <input
                          type="number"
                          placeholder="300"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Estado
                        </label>
                        <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8">
                          <option>Seleccionar estado</option>
                          <option>Aguascalientes</option>
                          <option>Baja California</option>
                          <option>Baja California Sur</option>
                          <option>Campeche</option>
                          <option>Chiapas</option>
                          <option>Chihuahua</option>
                          <option>Ciudad de México</option>
                          <option>Coahuila</option>
                          <option>Colima</option>
                          <option>Durango</option>
                          <option>Estado de México</option>
                          <option>Guanajuato</option>
                          <option>Guerrero</option>
                          <option>Hidalgo</option>
                          <option>Jalisco</option>
                          <option>Michoacán</option>
                          <option>Morelos</option>
                          <option>Nayarit</option>
                          <option>Nuevo León</option>
                          <option>Oaxaca</option>
                          <option>Puebla</option>
                          <option>Querétaro</option>
                          <option>Quintana Roo</option>
                          <option>San Luis Potosí</option>
                          <option>Sinaloa</option>
                          <option>Sonora</option>
                          <option>Tabasco</option>
                          <option>Tamaulipas</option>
                          <option>Tlaxcala</option>
                          <option>Veracruz</option>
                          <option>Yucatán</option>
                          <option>Zacatecas</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Ciudad
                        </label>
                        <input
                          type="text"
                          placeholder="Ciudad de México"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Dirección Completa
                      </label>
                      <input
                        type="text"
                        placeholder="Calle, Número, Colonia"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Descripción
                      </label>
                      <textarea
                        rows={4}
                        placeholder="Describe tu cancha, servicios incluidos, horarios..."
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                        maxLength={500}
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Características
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['Césped sintético', 'Césped natural', 'Iluminación', 'Estacionamiento', 'Vestidores', 'Gradas', 'Techada', 'Seguridad', 'Cafetería'].map((feature) => (
                          <label key={feature} className="flex items-center space-x-2 cursor-pointer">
                            <input type="checkbox" className="rounded border-gray-300 text-green-600 focus:ring-green-500" />
                            <span className="text-sm text-gray-700">{feature}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Imágenes de la Cancha
                      </label>
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                        <i className="ri-image-add-line text-4xl text-gray-400 mb-2"></i>
                        <p className="text-gray-600 mb-2">Arrastra imágenes aquí o haz clic para seleccionar</p>
                        <input type="file" multiple accept="image/*" className="hidden" id="image-upload" />
                        <label htmlFor="image-upload" className="cursor-pointer">
                          <Button variant="outline" size="sm" className="whitespace-nowrap">
                            Seleccionar Imágenes
                          </Button>
                        </label>
                      </div>
                    </div>
                    
                    <div className="flex justify-end space-x-4">
                      <Button variant="outline" className="whitespace-nowrap">
                        Guardar Borrador
                      </Button>
                      <Button className="bg-green-700 hover:bg-green-800 whitespace-nowrap">
                        Publicar Anuncio
                      </Button>
                    </div>
                  </form>
                </Card>
              </div>
            )}

            {/* Mi Perfil */}
            {activeTab === 'perfil' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-800">Mi Perfil</h2>
                  {!isEditing && (
                    <Button 
                      onClick={() => setIsEditing(true)}
                      variant="outline"
                      className="whitespace-nowrap border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white"
                    >
                      <i className="ri-edit-line mr-2"></i>
                      Editar Perfil
                    </Button>
                  )}
                </div>
                
                <div className="space-y-6">
                  {/* Información Personal */}
                  <Card className="p-6 border-2 border-red-200">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Información Personal</h3>
                    <div className="flex flex-col md:flex-row gap-8">
                      {/* Profile Picture */}
                      <div className="flex flex-col items-center">
                        <div className="relative">
                          <img
                            src={user.avatar}
                            alt={user.name}
                            className="w-32 h-32 rounded-full object-cover border-4 border-gray-200"
                          />
                          {isEditing && (
                            <label htmlFor="avatar-upload" className="absolute bottom-0 right-0 bg-green-600 text-white w-10 h-10 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-700 transition-colors">
                              <i className="ri-camera-line"></i>
                              <input
                                id="avatar-upload"
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                                className="hidden"
                              />
                            </label>
                          )}
                        </div>
                        <p className="text-sm text-gray-600 mt-2 text-center">
                          {isEditing ? 'Haz clic en la cámara para cambiar' : 'Foto de perfil'}
                        </p>
                      </div>
                      
                      {/* Personal Form */}
                      <div className="flex-1">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Nombre Completo
                            </label>
                            <input
                              type="text"
                              value={user.name}
                              onChange={(e) => setUser(prev => ({ ...prev, name: e.target.value }))}
                              disabled={!isEditing}
                              className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Correo Electrónico
                            </label>
                            <input
                              type="email"
                              value={user.email}
                              onChange={(e) => setUser(prev => ({ ...prev, email: e.target.value }))}
                              disabled={!isEditing}
                              className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Teléfono
                            </label>
                            <input
                              type="tel"
                              value={user.phone}
                              onChange={(e) => setUser(prev => ({ ...prev, phone: e.target.value }))}
                              disabled={!isEditing}
                              className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Estado
                            </label>
                            {isEditing ? (
                              <select 
                                value={user.state}
                                onChange={(e) => setUser(prev => ({ ...prev, state: e.target.value }))}
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8"
                              >
                                <option>Aguascalientes</option>
                                <option>Baja California</option>
                                <option>Baja California Sur</option>
                                <option>Campeche</option>
                                <option>Chiapas</option>
                                <option>Chihuahua</option>
                                <option>Ciudad de México</option>
                                <option>Coahuila</option>
                                <option>Colima</option>
                                <option>Durango</option>
                                <option>Estado de México</option>
                                <option>Guanajuato</option>
                                <option>Guerrero</option>
                                <option>Hidalgo</option>
                                <option>Jalisco</option>
                                <option>Michoacán</option>
                                <option>Morelos</option>
                                <option>Nayarit</option>
                                <option>Nuevo León</option>
                                <option>Oaxaca</option>
                                <option>Puebla</option>
                                <option>Querétaro</option>
                                <option>Quintana Roo</option>
                                <option>San Luis Potosí</option>
                                <option>Sinaloa</option>
                                <option>Sonora</option>
                                <option>Tabasco</option>
                                <option>Tamaulipas</option>
                                <option>Tlaxcala</option>
                                <option>Veracruz</option>
                                <option>Yucatán</option>
                                <option>Zacatecas</option>
                              </select>
                            ) : (
                              <input
                                type="text"
                                value={user.state}
                                disabled
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50"
                              />
                            )}
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Ciudad
                            </label>
                            <input
                              type="text"
                              value={user.city}
                              onChange={(e) => setUser(prev => ({ ...prev, city: e.target.value }))}
                              disabled={!isEditing}
                              className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>

                  {/* Información de la Empresa */}
                  <Card className="p-6 border-2 border-red-200">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Información de la Empresa</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre de la Empresa
                        </label>
                        <input
                          type="text"
                          value={user.company}
                          onChange={(e) => setUser(prev => ({ ...prev, company: e.target.value }))}
                          disabled={!isEditing}
                          className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          RFC/ID Fiscal
                        </label>
                        <input
                          type="text"
                          value={user.taxId}
                          onChange={(e) => setUser(prev => ({ ...prev, taxId: e.target.value }))}
                          disabled={!isEditing}
                          className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                        />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Dirección de la Empresa
                        </label>
                        <input
                          type="text"
                          value={user.companyAddress}
                          onChange={(e) => setUser(prev => ({ ...prev, companyAddress: e.target.value }))}
                          disabled={!isEditing}
                          className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Teléfono de la Empresa
                        </label>
                        <input
                          type="tel"
                          value={user.companyPhone}
                          onChange={(e) => setUser(prev => ({ ...prev, companyPhone: e.target.value }))}
                          disabled={!isEditing}
                          className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${!isEditing ? 'bg-gray-50' : ''}`}
                        />
                      </div>
                    </div>
                  </Card>

                  {isEditing && (
                    <div className="flex justify-end space-x-4">
                      <Button 
                        variant="outline" 
                        onClick={() => setIsEditing(false)}
                        className="whitespace-nowrap border-2 border-gray-400"
                      >
                        Cancelar
                      </Button>
                      <Button 
                        onClick={handleSaveProfile}
                        className="bg-green-700 hover:bg-green-800 whitespace-nowrap border-2 border-green-700"
                      >
                        Guardar Cambios
                      </Button>
                    </div>
                  )}

                  {/* Sección de Eliminar Cuenta */}
                  <Card className="p-6 border-2 border-red-300 bg-red-50">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                          <i className="ri-error-warning-line text-red-600 text-xl"></i>
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-red-800 mb-2">Zona de Peligro</h3>
                        <p className="text-red-700 mb-4">
                          Una vez que elimines tu cuenta, no hay vuelta atrás. Por favor, estate seguro.
                        </p>
                        <div className="bg-red-100 border border-red-200 rounded-lg p-3 mb-4">
                          <div className="flex items-start space-x-2">
                            <i className="ri-alert-line text-red-600 text-lg mt-0.5"></i>
                            <div>
                              <div className="font-medium text-red-800 text-sm mb-1">Al eliminar tu cuenta se perderá:</div>
                              <ul className="text-red-700 text-xs space-y-1">
                                <li>• Todas tus publicaciones y anuncios</li>
                                <li>• Historial de reservas y estadísticas</li>
                                <li>• Información del perfil y empresa</li>
                                <li>• Membresías y beneficios activos</li>
                                <li>• Esta acción es irreversible</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <Button 
                          onClick={handleDeleteAccount}
                          className="bg-red-600 hover:bg-red-700 text-white whitespace-nowrap border-2 border-red-600"
                        >
                          <i className="ri-delete-bin-line mr-2"></i>
                          Eliminar Cuenta Permanentemente
                        </Button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            )}

            {/* Membresías */}
            {activeTab === 'membresias' && (
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Planes de Membresía</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {memberships.map((plan) => (
                    <Card key={plan.id} className={`p-6 relative border-2 ${plan.current ? 'ring-2 ring-green-500 border-green-300' : 'border-red-200 hover:border-red-300'}`}>
                      {plan.current && (
                        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                          <span className="bg-green-500 text-white px-4 py-1 rounded-full text-sm font-medium whitespace-nowrap">
                            Plan Actual
                          </span>
                        </div>
                      )}
                      <div className="text-center mb-6">
                        <h3 className="text-xl font-bold text-gray-800 mb-2">{plan.name}</h3>
                        <div className="text-3xl font-bold text-green-600 mb-4">{plan.price}</div>
                      </div>
                      <ul className="space-y-3 mb-6">
                        {plan.features.map((feature, index) => (
                          <li key={index} className="flex items-center text-sm">
                            <i className="ri-check-line text-green-600 mr-3"></i>
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                      <Button 
                        className={`w-full whitespace-nowrap border-2 ${plan.current ? 'bg-gray-400 cursor-not-allowed border-gray-400' : 'bg-green-700 hover:bg-green-800 border-green-700'}`}
                        disabled={plan.current}
                      >
                        {plan.current ? 'Plan Activo' : 'Seleccionar Plan'}
                      </Button>
                    </Card>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal de Editar Publicación */}
      {showEditModal && editingPublication && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border-2 border-red-300">
            <div className="flex items-center justify-between p-6 border-b">
              <h3 className="text-xl font-bold text-gray-800">Editar Publicación</h3>
              <button
                onClick={handleCloseEditModal}
                className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            <div className="p-6">
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nombre de la Cancha
                    </label>
                    <input
                      type="text"
                      value={editingPublication.name}
                      onChange={(e) => setEditingPublication(prev => ({ ...prev, name: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Categoría
                    </label>
                    <select 
                      value={editingPublication.category}
                      onChange={(e) => setEditingPublication(prev => ({ ...prev, category: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8"
                    >
                      <option>Fútbol 11</option>
                      <option>Fútbol 7</option>
                      <option>Fútbol 5</option>
                      <option>Futsal</option>
                      <option>Fútbol Playa</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Precio por Hora
                    </label>
                    <input
                      type="number"
                      value={editingPublication.price}
                      onChange={(e) => setEditingPublication(prev => ({ ...prev, price: parseInt(e.target.value) }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Estado
                    </label>
                    <select 
                      value={editingPublication.state}
                      onChange={(e) => setEditingPublication(prev => ({ ...prev, state: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8"
                    >
                      <option>Aguascalientes</option>
                      <option>Baja California</option>
                      <option>Baja California Sur</option>
                      <option>Campeche</option>
                      <option>Chiapas</option>
                      <option>Chihuahua</option>
                      <option>Ciudad de México</option>
                      <option>Coahuila</option>
                      <option>Colima</option>
                      <option>Durango</option>
                      <option>Estado de México</option>
                      <option>Guanajuato</option>
                      <option>Guerrero</option>
                      <option>Hidalgo</option>
                      <option>Jalisco</option>
                      <option>Michoacán</option>
                      <option>Morelos</option>
                      <option>Nayarit</option>
                      <option>Nuevo León</option>
                      <option>Oaxaca</option>
                      <option>Puebla</option>
                      <option>Querétaro</option>
                      <option>Quintana Roo</option>
                      <option>San Luis Potosí</option>
                      <option>Sinaloa</option>
                      <option>Sonora</option>
                      <option>Tabasco</option>
                      <option>Tamaulipas</option>
                      <option>Tlaxcala</option>
                      <option>Veracruz</option>
                      <option>Yucatán</option>
                      <option>Zacatecas</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ciudad
                    </label>
                    <input
                      type="text"
                      value={editingPublication.city}
                      onChange={(e) => setEditingPublication(prev => ({ ...prev, city: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Estado de la Publicación
                    </label>
                    <select 
                      value={editingPublication.status}
                      onChange={(e) => setEditingPublication(prev => ({ ...prev, status: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8"
                    >
                      <option value="activo">Activo</option>
                      <option value="inactivo">Inactivo</option>
                      <option value="pendiente">Pendiente</option>
                    </select>
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Dirección Completa
                  </label>
                  <input
                    type="text"
                    value={editingPublication.address}
                    onChange={(e) => setEditingPublication(prev => ({ ...prev, address: e.target.value }))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Descripción
                  </label>
                  <textarea
                    rows={4}
                    value={editingPublication.description}
                    onChange={(e) => setEditingPublication(prev => ({ ...prev, description: e.target.value }))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                    maxLength={500}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Características
                  </label>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {['Césped sintético', 'Césped natural', 'Iluminación', 'Estacionamiento', 'Vestidores', 'Gradas', 'Techada', 'Seguridad', 'Cafetería'].map((feature) => (
                      <label key={feature} className="flex items-center space-x-2 cursor-pointer">
                        <input 
                          type="checkbox" 
                          checked={editingPublication.features?.includes(feature)}
                          onChange={(e) => {
                            const features = editingPublication.features || [];
                            if (e.target.checked) {
                              setEditingPublication(prev => ({ 
                                ...prev, 
                                features: [...features, feature] 
                              }));
                            } else {
                              setEditingPublication(prev => ({ 
                                ...prev, 
                                features: features.filter(f => f !== feature) 
                              }));
                            }
                          }}
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500" 
                        />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </label>
                    ))}
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Imagen de la Cancha
                  </label>
                  <div className="flex items-center space-x-4">
                    <img
                      src={editingPublication.image}
                      alt={editingPublication.name}
                      className="w-24 h-16 object-cover rounded-lg border"
                    />
                    <div className="flex-1">
                      <input type="file" accept="image/*" className="hidden" id="edit-image-upload" />
                      <label htmlFor="edit-image-upload" className="cursor-pointer">
                        <Button variant="outline" size="sm" className="whitespace-nowrap">
                          Cambiar Imagen
                        </Button>
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            
            <div className="flex justify-end space-x-4 p-6 border-t bg-gray-50">
              <Button variant="outline" onClick={handleCloseEditModal} className="whitespace-nowrap border-2 border-gray-400">
                Cancelar
              </Button>
              <Button 
                onClick={handleSaveEditedPublication}
                className="bg-green-700 hover:bg-green-800 whitespace-nowrap border-2 border-green-700"
              >
                Guardar Cambios
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Eliminar Publicación */}
      {showDeleteModal && deletingPublication && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full border-2 border-red-300">
            <div className="p-6">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full">
                <i className="ri-delete-bin-line text-red-600 text-2xl"></i>
              </div>
              
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">¿Eliminar Publicación?</h3>
                <p className="text-gray-600 mb-4">
                  Esta acción eliminará permanentemente la publicación "<strong>{deletingPublication.name}</strong>" y no se puede deshacer.
                </p>
                
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <div className="flex items-start space-x-2">
                    <img
                      src={deletingPublication.image}
                      alt={deletingPublication.name}
                      className="w-16 h-12 object-cover rounded border"
                    />
                    <div className="flex-1 text-left">
                      <div className="font-medium text-gray-800">{deletingPublication.name}</div>
                      <div className="text-sm text-gray-600">{deletingPublication.location}</div>
                      <div className="text-sm text-green-600 font-medium">${deletingPublication.price}/hora</div>
                    </div>
                  </div>
                </div>
                
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
                  <div className="flex items-start space-x-2">
                    <i className="ri-alert-line text-red-600 text-lg mt-0.5"></i>
                    <div className="text-left">
                      <div className="font-medium text-red-800 text-sm">Consecuencias de eliminar:</div>
                      <ul className="text-red-700 text-xs mt-1 space-y-1">
                        <li>• Se perderán todas las estadísticas ({deletingPublication.views} visualizaciones)</li>
                        <li>• Se cancelarán las reservas pendientes ({deletingPublication.bookings} reservas)</li>
                        <li>• La publicación desaparecerá de los resultados de búsqueda</li>
                        <li>• Esta acción no se puede revertir</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="flex space-x-3">
                <Button 
                  variant="outline" 
                  onClick={handleCloseDeleteModal}
                  className="flex-1 whitespace-nowrap border-2 border-gray-400"
                >
                  Cancelar
                </Button>
                <Button 
                  onClick={handleConfirmDelete}
                  className="flex-1 bg-red-600 hover:bg-red-700 text-white whitespace-nowrap border-2 border-red-600"
                >
                  <i className="ri-delete-bin-line mr-2"></i>
                  Eliminar Definitivamente
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Eliminar Cuenta */}
      {showDeleteAccountModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full border-2 border-red-300">
            <div className="p-6">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full">
                <i className="ri-user-unfollow-line text-red-600 text-2xl"></i>
              </div>
              
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">¿Eliminar Cuenta Definitivamente?</h3>
                <p className="text-gray-600 mb-4">
                  Esta acción eliminará permanentemente tu cuenta "<strong>{user.name}</strong>" y todos tus datos asociados.
                </p>
                
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                  <div className="flex items-start space-x-2">
                    <i className="ri-alert-line text-red-600 text-lg mt-0.5"></i>
                    <div className="text-left">
                      <div className="font-medium text-red-800 text-sm">Datos que se eliminarán permanentemente:</div>
                      <ul className="text-red-700 text-xs mt-1 space-y-1">
                        <li>• Todas las publicaciones ({userPublications.length} anuncios)</li>
                        <li>• Información personal y empresarial</li>
                        <li>• Historial de estadísticas y reservas</li>
                        <li>• Membresía {user.license} activa</li>
                        <li>• Acceso a la plataforma permanentemente</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
                  <div className="text-yellow-800 text-sm">
                    <i className="ri-information-line mr-1"></i>
                    <strong>Nota:</strong> Si tienes reservas activas, se cancelarán automáticamente y se notificará a los clientes.
                  </div>
                </div>
              </div>
              
              <div className="flex space-x-3">
                <Button 
                  variant="outline" 
                  onClick={handleCloseDeleteAccountModal}
                  className="flex-1 whitespace-nowrap border-2 border-gray-400"
                >
                  Cancelar
                </Button>
                <Button 
                  onClick={handleConfirmDeleteAccount}
                  className="flex-1 bg-red-600 hover:bg-red-700 text-white whitespace-nowrap border-2 border-red-600"
                >
                  <i className="ri-delete-bin-line mr-2"></i>
                  Eliminar Definitivamente
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
